export default __webpack_public_path__ + "static/media/480.c801926b.jpg";